import { AccountActionTypeIds, AccountActionTypes } from "../action-types/accountActionTypes";

export interface IAccountState {
    isLoading: boolean,
    message?: string
}
const initialState: IAccountState = {
    isLoading: false,
    message: undefined
}
const accountReducer = (state: IAccountState =initialState, action: AccountActionTypes): IAccountState => {
    switch (action.type) {
        case AccountActionTypeIds.LOGIN_START:
            return {
                ...state,
                isLoading: true,
                message: undefined
            }
        case AccountActionTypeIds.LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                message: undefined
            }
        case AccountActionTypeIds.LOGIN_ERROR:
            return {
                ...state,
                isLoading: false,
                message: action.payload

            }
        default:
            return state;
    }
}
export { accountReducer }